import { render, staticRenderFns } from "./DynamicIndex.vue?vue&type=template&id=992e4d3e&scoped=true&"
import script from "./DynamicIndex.vue?vue&type=script&lang=ts&"
export * from "./DynamicIndex.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicIndex.vue?vue&type=style&index=0&id=992e4d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992e4d3e",
  null
  
)

export default component.exports